module.exports = __webpack_public_path__ + "img/top-10-main.0ee95552.jpg";